<template>
  <nav class="nav-box">
    <div class="nav-bar">
      <router-link class="item" v-for="(item,index) in navs" :to="item.link" :key="index" exact>
        <span v-if="!item.isImg">{{item.name}}</span>
        <span v-else><img :src="item.imgUrl" alt=""></span>
      </router-link>
    </div>
  </nav>
</template>

<script>
  export default {
    name: "NavBar",
    props:{
      navs: Array
    }
  }
</script>

<style lang="less" scoped>
  .nav-box{
    width: 100%;
    height: 90px;
    padding: 0 30px;
    box-sizing: border-box;
  }
  .nav-bar{
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    width: 100%;
    height: 66px;
    box-sizing: border-box;
    .item{
      font-size: 28px;
      color: #AEAEAE;
      position: relative;
      text-decoration: none;
      display: flex;
      align-self: flex-end;
      &.is-active{
        font-weight: bold;
        color: #333;
        text-decoration: none;
        font-size: 34px;
        /*transform-origin: center bottom;*/
        /*transform: scale(1.2);*/
        &:after {
          width: 8px;
          height: 8px;
          background: #FF393A;
          display: block;
          content: "";
          border-radius: 30px;
          position: absolute;
          bottom: -10px;
          left: 50%;
          margin-left: -5px;
        }
        span{
          margin-bottom: -1px;/*no*/
        }
        img{
          vertical-align: middle;
          height: 42px;
        }
      }
      img{
        vertical-align: middle;
        height: 32px;
        margin-bottom: 2px;/*no*/
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/header/NavBar.vue